import { render, staticRenderFns } from "./MarketplaceDropDown.vue?vue&type=template&id=a5bc6808&"
import script from "./MarketplaceDropDown.vue?vue&type=script&lang=js&"
export * from "./MarketplaceDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports